module.exports = __webpack_public_path__ + "img/check.c285430b.svg";